<!--
 * @Author: Ashley.Liu
 * @Date: 2022-02-27 21:33:12
 * @LastEditTime: 2022-06-22 12:27:17
 * @Description: operation guide
-->
<template>
  <zm-tooltip
    placement="bottom"
    ref="tooltip"
    :content="tooltipContent"
    effect="dark"
    manual
    v-model="tooltipShow"
    popper-class="opration-guide"
  >
    <template #content>
      <div class="pdt-sm pdl-sm ">
        <div class="mgb-md text">{{tooltipContent}}</div>
        <div class="as-flex-row as-flex-ai-center as-flex-jc-end">
          <!-- <div
            class="mgr-sm mgt-md"
            style="font-weight: 600;"
          > Click OK to let me know you got it.</div> -->
          <zm-button
            class="mgb-md mgr-md"
            @click="showTooltips(true)"
          >OK, I got it !</zm-button>
        </div>
      </div>
    </template>
  </zm-tooltip>
</template>

<script>
// import { debounce } from 'lodash'
export default {
  name: 'OperationGuide',
  props: {
    elements: {
      type: Array,
      default: () => []
    },
    modules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tooltipContent: '',
      tooltipShow: false,
      index: 0
    }
  },
  watch: {
    tooltipShow (v) {
      const dom = document.querySelector('#app')
      if (v) {
        dom.classList.add('disable-app')
      } else {
        dom.classList.remove('disable-app')
      }
    },
    elements () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      localStorage.tooltipOk = ''
      this.tooltipContent = ''
      this.tooltipShow = false
      this.index = 0
      // if (this.getCache()) return
      if (this.modules.length === 0) return
      this.$nextTick(() => {
        this.showTooltips()
      })
    },
    setCache (isOk) {
      const tooltipIsOk = JSON.parse(localStorage.getItem('tooltipIsOk'))
      let moduleCacheObj = {}
      this.modules.forEach(x => {
        moduleCacheObj[x] = true
      })
      localStorage.setItem('tooltipIsOk', JSON.stringify(Object.assign({}, tooltipIsOk, moduleCacheObj)))
    },
    getCache () {
      if (!localStorage.tooltipIsOk) return
      return JSON.parse(localStorage.tooltipIsOk)?.[this.module]
    },
    showTooltips (isOk) {
      if (this.index >= this.elements.length) {
        this.tooltipShow = false
        if (isOk) {
          this.setCache(true)
        }
        this.$emit('update:elements', null)
        return
      }
      const item = this.elements[this.index]

      this.index++
      // if element is undefiend,take next element
      if (!item) {
        this.showTooltips()
        return
      }
      const tooltip = this.$refs.tooltip
      this.tooltipContent = item.content
      tooltip.referenceElm = item.el
      if (tooltip.showPopper) {
        this.tooltipShow = false
        this.$nextTick(() => {
          tooltip.updatePopperReference(item.el)
          tooltip.updatePopper()
          this.tooltipShow = true
        })
      }
      tooltip.show()
      this.tooltipShow = true
    }
  }
}
</script>

<style lang="scss">
.opration-guide.zm-tooltip__popper {
  max-width: 500px;
  .text {
    font-size: 18px;
    line-height: 24px;
    // text-align: justify;
  }
}
.disable-app {
  pointer-events: none;
}
</style>
